import truckDriverPng from '../../assets/truck_driver.png';

/** Map marker + list thumbnail (same asset). */
export const LIVE_VEHICLE_MAP_ICON_URL = truckDriverPng;

const DETAIL_VEHICLE_IMAGE =
  'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=200&h=140&fit=crop&q=80';

const TELEMETRY_BY_INDEX = [
  {
    status: 'WORKING',
    tracker_serial: '1023',
    last_connected_time: '1:00 PM',
    speed_kmh: 65,
    direction_label: 'NE',
    direction_degrees: 45,
    mileage_km: 12458,
    fuel_percent: 68,
    altitude_m: 920,
    recorded_at: '24 May 2025 12:45 PM',
    recorder_speed_kmh: 64,
  },
  {
    status: 'WORKING',
    tracker_serial: '1024',
    last_connected_time: '7:55 AM',
    speed_kmh: 52,
    direction_label: 'E',
    direction_degrees: 90,
    mileage_km: 9820,
    fuel_percent: 74,
    altitude_m: 410,
    recorded_at: '20 May 2025 07:55 AM',
    recorder_speed_kmh: 50,
  },
  {
    status: 'WORKING',
    tracker_serial: '1025',
    last_connected_time: '7:40 AM',
    speed_kmh: 48,
    direction_label: 'SW',
    direction_degrees: 225,
    mileage_km: 15620,
    fuel_percent: 41,
    altitude_m: 305,
    recorded_at: '20 May 2025 07:40 AM',
    recorder_speed_kmh: 47,
  },
  {
    status: 'OFFLINE',
    tracker_serial: '1026',
    last_connected_time: '6:20 PM',
    speed_kmh: 0,
    direction_label: 'N',
    direction_degrees: 0,
    mileage_km: 22100,
    fuel_percent: 55,
    altitude_m: 380,
    recorded_at: '19 May 2025 06:20 PM',
    recorder_speed_kmh: 0,
  },
  {
    status: 'WORKING',
    tracker_serial: '1027',
    last_connected_time: '6:05 AM',
    speed_kmh: 71,
    direction_label: 'NW',
    direction_degrees: 315,
    mileage_km: 8900,
    fuel_percent: 82,
    altitude_m: 120,
    recorded_at: '20 May 2025 06:05 AM',
    recorder_speed_kmh: 69,
  },
];

function withTelemetry(vehicle, index) {
  const preset = TELEMETRY_BY_INDEX[index % TELEMETRY_BY_INDEX.length];
  return {
    ...vehicle,
    ...preset,
    detail_image_url: DETAIL_VEHICLE_IMAGE,
  };
}

/**
 * Demo fleet: Telangana-area stops with coordinates for map markers.
 * Shape matches `VehicleDetails` / map wiring (`lat`, `lng`, `license_plate`, …).
 */
const RAW_LIVE_VEHICLES = [
  {
    id: 'lv-1',
    patrol_id: 'lv-1',
    name: 'Patancheru (Hyderabad)',
    lat: 17.53,
    lng: 78.27,
    license_plate: 'KA01AB1234',
    last_connected_at: '2026-05-20 08:12AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-2',
    patrol_id: 'lv-2',
    name: 'Enumamula (Warangal)',
    lat: 17.9745,
    lng: 79.6113,
    license_plate: 'TS09 LV 1002',
    last_connected_at: '2026-05-20 07:55AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-3',
    patrol_id: 'lv-3',
    name: 'Suryapet',
    lat: 17.1415,
    lng: 79.6236,
    license_plate: 'TS09 LV 1003',
    last_connected_at: '2026-05-20 07:40AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-4',
    patrol_id: 'lv-4',
    name: 'Nizamabad',
    lat: 18.672,
    lng: 78.094,
    license_plate: 'TS09 LV 1004',
    last_connected_at: '2026-05-19 06:20PM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-5',
    patrol_id: 'lv-5',
    name: 'Khammam',
    lat: 17.25,
    lng: 80.15,
    license_plate: 'TS09 LV 1005',
    last_connected_at: '2026-05-20 06:05AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-6',
    patrol_id: 'lv-6',
    name: 'Karimnagar',
    lat: 18.4391,
    lng: 79.1285,
    license_plate: 'TS09 LV 1006',
    last_connected_at: '2026-05-19 11:48PM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-7',
    patrol_id: 'lv-7',
    name: 'Adilabad',
    lat: 19.6713,
    lng: 78.5334,
    license_plate: 'TS09 LV 1007',
    last_connected_at: '2026-05-20 05:30AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-8',
    patrol_id: 'lv-8',
    name: 'Ramagundam',
    lat: 18.755,
    lng: 79.474,
    license_plate: 'TS09 LV 1008',
    last_connected_at: '2026-05-20 04:15AM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-9',
    patrol_id: 'lv-9',
    name: 'Mahbubnagar',
    lat: 16.7488,
    lng: 78.0035,
    license_plate: 'TS09 LV 1009',
    last_connected_at: '2026-05-19 09:10PM',
    image_url: truckDriverPng,
  },
  {
    id: 'lv-10',
    patrol_id: 'lv-10',
    name: 'Miryalaguda',
    lat: 16.8722,
    lng: 79.5624,
    license_plate: 'TS09 LV 1010',
    last_connected_at: '2026-05-20 03:22AM',
    image_url: truckDriverPng,
  },
];

export const INITIAL_LIVE_VEHICLES = RAW_LIVE_VEHICLES.map(withTelemetry);
